import React, { useEffect } from 'react';
import { Button, Card, Form, Input, Space } from 'antd';
import StoreSettingService from 'services/store_setting';
import ImagePicker from 'components/pickers/image/ImagePicker';
import { useApp } from 'contexts/app';

const service = new StoreSettingService();

const normalizeImageForForm = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value === 'string') {
    return { url: value };
  }

  return value;
};

const normalizeImageForPayload = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object') {
    return value;
  }

  return null;
};

const SocialShare = () => {
  const [form] = Form.useForm();
  const { showLoading, showNotify, message } = useApp();

  const loadData = async () => {
    showLoading(true);
    try {
      const data = await service.getSEOSocialShareSetting();

      form.setFieldsValue({
        title: data?.title || '',
        description: data?.description || '',
        image: normalizeImageForForm(data?.image),
      });
    } catch (error) {
      message.error(error?.message || 'Không thể tải cấu hình Social Share');
    }
    showLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const onFinish = async (values) => {
    showLoading(true);
    try {
      const payload = {
        title: values?.title || '',
        description: values?.description || '',
        image: normalizeImageForPayload(values?.image),
      };

      await service.saveSEOSocialShareSetting(payload);
      showNotify('Đã lưu cấu hình Social Share');
      await loadData();
    } catch (error) {
      message.error(error?.message || 'Không thể lưu cấu hình Social Share');
    }
    showLoading(false);
  };

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Card title="Social Share (Open Graph)">
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item label="Tiêu đề chia sẻ" name="title">
            <Input maxLength={120} placeholder="Nhập tiêu đề chia sẻ" />
          </Form.Item>

          <Form.Item label="Mô tả chia sẻ" name="description">
            <Input.TextArea rows={3} maxLength={320} placeholder="Nhập mô tả chia sẻ" />
          </Form.Item>

          <Form.Item label="Hình ảnh chia sẻ" name="image">
            <ImagePicker />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">Lưu Social Share</Button>
          </Form.Item>
        </Form>
      </Card>
    </Space>
  );
};

export default SocialShare;
